import React from 'react'

function NavBar() {
  return <div>
      <h1 className="text-3xl    
      font-bold bg-red-50 text-red-900 font-sans text-left py-3 px-5">
        Appointment Bookings
      </h1>
    </div>
}

export default NavBar
